import { Button, Dialog, DialogActions, DialogContent } from "@mui/material";
import { useTranslation } from "react-i18next";
import BootstrapDialogTitle from "../../../components/BootstrapDialogTitle";
import styles from "./Approvers.Dialogs.module.scss";

interface PropsBase {
  open: boolean;
  onClose: () => void;
  className?: string | undefined;
  text?: string;
}

interface Props extends PropsBase {
  onAccept: () => void;
  title?: string;
  saving?: boolean;
}

export const ConfirmDialog: React.FC<Props> = ({
  open,
  title,
  text,
  onAccept,
  onClose,
  className,
  saving,
}) => {
  const { t } = useTranslation();

  return (
    <Dialog
      className={`${styles.cancelDialog} ${className ?? ""}`}
      open={open}
      fullWidth
      maxWidth="sm"
    >
      <BootstrapDialogTitle onClose={onClose}>{title}</BootstrapDialogTitle>
      <DialogContent>
        <p>{text}</p>
      </DialogContent>
      <DialogActions>
        <Button
          className={styles.yes}
          variant="contained"
          onClick={() => onAccept()}
          disabled={saving}
        >
          {t("yes")}
        </Button>
        <Button
          className={styles.no}
          variant="contained"
          onClick={() => onClose()}
          disabled={saving}
        >
          {t("no")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export const AlertDialog: React.FC<PropsBase> = ({
  open,
  text,
  onClose,
  className,
}) => {
  const { t } = useTranslation();

  return (
    <Dialog
      className={`${styles.cancelDialog} ${className ?? ""}`}
      open={open}
      fullWidth
      maxWidth="sm"
    >
      <BootstrapDialogTitle onClose={onClose}></BootstrapDialogTitle>
      <DialogContent>
        <p>{text}</p>
      </DialogContent>
      <DialogActions>
        <Button
          className={styles.no}
          variant="contained"
          onClick={() => onClose()}
        >
          {t("Close")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};